import Create from '../views/companies/Create.vue'
import CreateStep1 from '../views/companies/create/Step1.vue'
import CreateStep2 from '../views/companies/create/Step2.vue'
import CreateStep3 from '../views/companies/create/Step3.vue'
import Index from '../views/companies/Index.vue'
import Update from '../views/companies/Update.vue'

export default [{
    path: '/companies',
    name: 'companies',
    component: Index,
    meta: { title: 'Unternehmen' }
}, {
    path: '/companies/index',
    redirect: '/companies'
}, {
    path: '/companies/create',
    component: Create,
    meta: { title: 'Unternehmen anlegen' },
    children: [{
        path: '',
        name: 'companies/create',
        component: CreateStep1
    }, {
        path: '2',
        name: 'companies/create/step2',
        component: CreateStep2
    }, {
        path: '3',
        name: 'companies/create/step3',
        component: CreateStep3
    }]
}, {
    path: '/companies/:id',
    name: 'companies/update',
    component: Update,
    meta: { title: 'Unternehmen bearbeiten' }
}]
